import { graphql } from '../../gql';

export const VAGO_CLIENT_SUMMARY = graphql(`
  query vagoClientSummary($token: String!) {
    vagoClientSummary(token: $token)
  }
`);
